import { inject, Injectable } from '@angular/core';
import { AuthStorageService } from '@spartacus/core';
import { UserJwtAuthority } from '@user/const';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class JwtUserRoleService {
  private readonly authStorageService = inject(AuthStorageService);

  getAuthorities(): Observable<string[]> {
    return this.authStorageService.getToken().pipe(map((token) => this.extractAuthorities(token?.refresh_token)));
  }

  hasAuthority(authority: UserJwtAuthority): Observable<boolean> {
    const expected = authority.toUpperCase();

    return this.getAuthorities().pipe(
      map((authorities) => authorities.some((item) => item.toUpperCase() === expected)),
    );
  }

  private extractAuthorities(refreshToken?: string): string[] {
    if (!refreshToken) {
      return [];
    }

    try {
      const payload = JSON.parse(atob(refreshToken.split('.')[1]));
      const authorities = payload?.authorities;

      return Array.isArray(authorities) ? authorities.map(String) : [];
    } catch {
      return [];
    }
  }
}
